import { render, staticRenderFns } from "./YouTubeSection.vue?vue&type=template&id=e74e8164&scoped=true"
import script from "./YouTubeSection.vue?vue&type=script&lang=js"
export * from "./YouTubeSection.vue?vue&type=script&lang=js"
import style0 from "./YouTubeSection.vue?vue&type=style&index=0&id=e74e8164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74e8164",
  null
  
)

export default component.exports